import { useMemo } from "react";
import { makeQueryString } from "core/makeQueryString";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import isNil from "lodash/isNil";
import { Machine } from "interfaces/machine";

export interface GetMachineResponse {
  loading: boolean;
  error: boolean;
  machine: Machine | undefined;
}

export function useGetMachineById(
  machineId: number | undefined,
  page: number = 1,
  pageSize: number = 10000
): GetMachineResponse {
  const url = useMemo(
    () =>
      `machines/${machineId}` +
      makeQueryString({
        page,
        size: pageSize
      }),
    [machineId, page, pageSize]
  );
  const { loading, error, response } = useFetchGetV2(url, isNil(machineId));

  return {
    loading,
    error,
    machine: response
  };
}
